import {
  getPlatformExecuteAdHocQueryTeamMockHandler,
  getPlatformExecuteAdHocQueryTeamResponseMock,
} from '@cloudquery/api-platform';

import { resourceCategoriesSQLQuery } from '@/components/asset-inventory';

import adhocQueryForResourceCategories from './data/adhocQueryForResourceCategories.json';

export const getCustomPlatformExecuteAdHocQueryTeamMockHandler = () => {
  return getPlatformExecuteAdHocQueryTeamMockHandler(async (info) => {
    const body = await info.request.json();

    if ((body as any)?.query === resourceCategoriesSQLQuery) {
      return { data: adhocQueryForResourceCategories } as any;
    }

    return getPlatformExecuteAdHocQueryTeamResponseMock();
  });
};
